export const mmddyyyyWithSlashes = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/\d{4}$/;
export const dateFormatFlexible = /^(\d{1,2}\/\d{1,2}\/\d{4})/;
export const datepickerAllowedChars = /[0-9/,-]|(Backspace)|(Tab)|(ArrowLeft)|(ArrowRight)|(Delete)|(Home)|(End)/;
export const toAccountAllowedChars = /[0-9]|(Backspace)|(Tab)|(ArrowLeft)|(ArrowRight)|(Delete)|(Home)|(End)/;
export const abaAllowedChars = toAccountAllowedChars;
export const taxPayerAllowedChars = toAccountAllowedChars;
export const amountAllowedChars = /[0-9.,]|(Backspace)|(Tab)|(ArrowLeft)|(ArrowRight)|(Delete)|(Home)|(End)/;
export const percentAllowedChars = /[0-9.]|(Backspace)|(Tab)|(ArrowLeft)|(ArrowRight)|(Delete)|(Home)|(End)/;
export const beneficiaryAccountNumberAllowedChars = /[-a-zA-Z0-9()',?:+/.\n\r ]/;
export const beneficiaryAccountNumberNotAllowedChars = /[^-a-zA-Z0-9()',?:+/.\n\r ]/g;
export const alphaNumericChars = /^[a-zA-Z0-9]+$/;
export const wireTransmissionNotesAllowedChars = '[a-zA-Z0-9+\\/.\\-(),?:\' \\n]*';
export const numeralsOnly = /^[0-9]+$/;
export const zipCodeAllowedChars = /[0-9-]|(Backspace)|(Tab)|(ArrowLeft)|(ArrowRight)|(Delete)|(Home)|(End)/;
export const zipCodePattern = /^\d{5}(?:[-]\d{4})?$/;
export const numberOrDecimalOnly = /^[1-9]\d*(\.\d+)?$/;
export const upToThreeDecimalsOnly = /^\d*(\.\d{0,3})?$/;
export const whitespaceNewlinesAndTabs = /[\s\t\n\r]/g;

export const receivingAccountAllowedChars = '[a-zA-Z0-9()\',?:+\\/.\\- ]*';
export const intermediaryAllowedChars = receivingAccountAllowedChars;
export const firstCharAlphaNumeric = /^[a-zA-Z0-9 ]/;
export const intermediaryPhoneFormat = /\d{3}-\d{3}-\d{4}( Ext\. \d{1,4}|$)/;
export const emailValidationPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/;
export const nicknameAllowedCharacters = /^[a-zA-Z0-9 #$%&'*]*$/;
export const InhIraAccountAbreviations = /inh|ihira|ihnsr|ihirh/;

export const isoFieldsAllowedChars = '[a-zA-Z0-9()\'`,?:+\\/.\\-!#$%&*=^_ {|}~";<>@[\\\]\\\\]*';

export const amountAllowedPattern = /^[0-9~`!@#$%^&*()_ +={}\[\]|\\:;\"'<>,.?/-]*$/;
export const taxTypeAllowedChars= /[A-Z0-9]|(Backspace)|(Tab)|(ArrowLeft)|(ArrowRight)|(Delete)|(Home)|(End)/;
export const taxTypeCodeValidation = /^[A-Z0-9]+$/;